"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _moment = _interopRequireDefault(require("moment"));

var _displayFormats = require("../utils/displayFormats");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

var getUpdatedDate = function getUpdatedDate(value, field, currentDate) {
  var numVal = +value;
  var currentAmOrPm = currentDate.format(_displayFormats.hhmmA).split(' ')[1];

  if (field === 'hour') {
    var currentHour = currentDate.hour();
    var newHour = numVal;

    if (currentHour === 0) {
      // 12AM: display val === 12
      if (numVal === 13) newHour = 1; //  12 + 1 = 13, but 12AM + 1hr = 1AM  (01:00)

      if (numVal === 11) newHour = 23; // 12 - 1 = 11, but 12AM - 1hr = 11PM (23:00)
    } else if (currentAmOrPm === 'PM') {
      if (numVal > 0 && numVal < 12) newHour = numVal + 12;
      if (currentHour === 23 && numVal === 12) newHour = 0; // 23+1hr: 11PM -> 12AM

      if (currentHour === 12 && numVal === 11) newHour = 11; // -1hr: 12PM -> 11AM

      if (currentHour === 13 && numVal === 0) newHour = 12; //  -1hr: 1PM -> 12PM
    }

    return (0, _moment["default"])(currentDate).hour(newHour);
  }

  if (field === 'minute') {
    var newMinute = numVal;
    if (numVal === 60) newMinute = 0;
    if (numVal === -1) newMinute = 59;
    return (0, _moment["default"])(currentDate).minute(newMinute);
  }

  if (field === 'AM/PM') {
    var newAmOrPm = value;
    if (currentAmOrPm === newAmOrPm) return currentDate;
    if (currentAmOrPm === 'AM' && newAmOrPm === 'PM') return (0, _moment["default"])(currentDate).add(12, 'hours');
    if (currentAmOrPm === 'PM' && newAmOrPm === 'AM') return (0, _moment["default"])(currentDate).subtract(12, 'hours');
  }

  throw new Error("Invalid field ".concat(field, "; expected 'hour', 'minute', or 'AM/PM"));
};

var _default = getUpdatedDate;
exports["default"] = _default;